import { createSlice } from "@reduxjs/toolkit";

export const loginuser = createSlice({
  name: "loginuser",
  initialState: {
    login: JSON.parse(localStorage.getItem("login")),
    tokenReady: false,
    userDetail: null,
    tempToken: null,
    accessToken: null,
    idToken: null,
    accessTokenExpiresAt: null,
    accessTokenExpiresIn: null,
  },
  reducers: {
    setTempToken: (state, action) => {
      state.tempToken = action.payload;
    },

    setLogin: (state, action) => {
      state.login = action.payload;
    },
    // Set OAuth tokens from token exchange
    setOAuthTokens: (state, action) => {
      state.login = action.payload.login;
      state.tokenReady = action.payload.tokenReady;
      state.idToken = action.payload.idToken;
      state.accessToken = action.payload.accessToken;
      state.accessTokenExpiresAt = action.payload.accessTokenExpiresAt;
      state.accessTokenExpiresIn = action.payload.accessTokenExpiresIn;
      state.userDetail = { ...action.payload.userDetail };
    },

    updateUserDetail: (state, action) => {
      state.userDetail = action.payload;
    },
    // Update access token after refresh
    updateAccessToken: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.accessTokenExpiresIn = action.payload.accessTokenExpiresIn;
    },
    // Set authorization code from OAuth callback
    setAuthorizationCode: (state, action) => {
      state.authorizationCode = action.payload.code;
      state.codeVerifier = action.payload.codeVerifier;
    },
    logout: (state) => {
      state.login = false;
      state.token = null;
      state.userDetail = null;
      state.tempToken = null;
      state.accessToken = null;
      state.accessTokenExpiresIn = null;
      state.accessTokenExpiresAt = null;
      state.authorizationCode = "";
      state.codeVerifier = "";
      localStorage.removeItem("plan");
      localStorage.removeItem("coupon");
      localStorage.setItem("login", false);
    },
  },
});

export const {
  setLogin,
  logout,
  setTempToken,
  setOAuthTokens,
  updateAccessToken,
  setAuthorizationCode,
  updateUserDetail,
} = loginuser.actions;

export default loginuser.reducer;

export const getLogin = (state) => state.loginuser.login;

export const getToken = (state) => state.loginuser.accessToken;

export const getTempToken = (state) => state.loginuser.tempToken;

export const getTokenReady = (state) => state.loginuser.tokenReady;

export const getUserDetail = (state) => state.loginuser.userDetail;

